<template>
  <div class="class-time">
    <div class="clock-icon flex-stretch" v-html="require('@/assets/clock.svg')"></div>
    <div class="class-id">{{ timeNum }}</div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {mapState} from "vuex";

export default {
  name: "roomTimer",
  props:{
    time: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      duration: 0,
      timer: null,
    }
  },
  computed: {
    timeNum() {
      if (!this.duration) {
        return '00:00:00'
      } else {
        let hours = Math.floor(this.duration / 3600);
        let minutes = Math.floor((this.duration % 3600) / 60);
        let seconds = Math.floor(this.duration % 60);
        hours = hours.toString().padStart(2, '0');
        minutes = minutes.toString().padStart(2, '0');
        seconds = seconds.toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`
      }
    },
    ...mapState([
      'classInfo' // 映射 this.items 为 this.$store.state.items
    ])
  },
  watch: {
    time(){
      if (this.time) {
        this.duration = this.time
      }
    },
    // 观察 classInfo 变化
    classInfo(newVal, oldVal) {
      if (newVal) {
        // 在这里执行你需要的操作
        if (!newVal.actualBeginTime) return
        let beginTime = dayjs(newVal.actualBeginTime).unix()
        let nowTime = dayjs().unix()
        this.duration = nowTime - beginTime
        this.timer = setInterval(() => {
          this.duration++
          let lessonTime = this.$route.query.classification == '1' ? (+this.classInfo.lessonTime) * 60 : 3600
          if( (lessonTime - this.duration) == 300){
            this.$notify({
              title: '提示',
              message: '课程还有五分钟结束，请做好准备',
              position: 'top-left',
              duration: 0
            });
          }
        }, 1000)
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
}
</script>

<style scoped lang="scss">
.class-time {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.clock-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.class-id {
  color: #4E5969;
  font-size: 14px;
  white-space: nowrap;

}
</style>